import 'bootstrap-icons/font/bootstrap-icons.css';
import Logo         from "../assets/test.png";
import Styles       from "./home.module.css";
import { useEffect, useState } from 'react';
import { updateState, fetchStates, getSignedImageUrl, getS3FolderImages, getItem } from "../api";

//Navigator
export const Navigater    = ( props ) => {
    const { setColor, setPage, } = props;
    const { Navigater } = Styles;
    const [ selected, setSelected ] = useState("home");

    const onClick = ( page )=>{
        switch(page){
            case "profile"  : setColor("#e91e63"); setSelected("profile" ); break;
            case "favorite" : setColor("#9c27b0"); setSelected("favorite"); break;
            case "search"   : setColor("#673ab7"); setSelected("search"  ); break;
            default         : setColor("#3f51b5"); setSelected("home"    ); break;
        }
        setPage(page);
    };

    return (
        <nav className={ Navigater }>
            <NavButton 
                onClick  = { onClick             } 
                page     = { "profile"           }  
                icon     = { "bi bi-person-fill" } 
                label    = { "حسابي"            } 
                selected = { selected            } 
                color    = { "#e91e63"           }
            />
            <NavButton 
                onClick  = { onClick            } 
                page     = { "favorite"         } 
                icon     = { "bi bi-heart-fill" } 
                label    = { "المفضلة"         } 
                selected = { selected           } 
                color    = { "#9c27b0"          }
            />
            <NavButton 
                onClick  = { onClick        } 
                page     = { "search"       }   
                icon     = { "bi bi-search" } 
                label    = { "البحث"       } 
                selected = { selected       } 
                color    = { "#673ab7"      }
            />
            <NavButton 
                onClick  = { onClick                 } 
                page     = { "home"                  }     
                icon     = { "bi bi-house-door-fill" } 
                label    = { "الرئيسية"             } 
                selected = { selected                } 
                color    = { "#3f51b5"               }
            />
        </nav>
    );
};
const        NavButton    = ( props ) => {
    const { icon, label, selected, color, onClick, page } = props;
    const { NavButton } = Styles;
    return (
        <div 
            onClick   = { _=> onClick(page) } 
            className = { NavButton         } 
            style     = {{ background: selected === page && color, color: selected === page && "white" }}
        >
            <i className={ icon  }></i>
            <p          >{ label }</p>
        </div>
    );
};
//Header
export const Header       = ( props ) => {
    const { bgColor } = props;
    const { Header, logo, links } = Styles;
    return(
        <header className = { Header } style={{ background: bgColor && bgColor }}>
            <div className = { links }>
                <a href="https://t.me/ali1234fgh"><i className="bi bi-telegram"></i></a>
                <a href="https://www.facebook.com/share/1AE7PNfWX2/"><i className="bi bi-facebook"></i></a>
                <a href="https://www.tiktok.com/@7amazon84?_t=ZS-8v9Xx0QoaXo&_r=1"><i className="bi bi-tiktok"></i></a>
            </div>
            <div className = { logo }>
                <h1>اليقين للأجهزة الأوربية</h1>
                <div><img src={ Logo } alt='اليقين للأجهزة الأوربية'/></div>
            </div>
        </header>
    );
};
//element
export const Element      = ( props ) => {
    const { id, album, title, label, img, price, setViewWindow, setViewRequest, setItemId, itemIdi, viewWindow, viewRequest } = props;
    const { Element, image, caption, EventHandler, buyBtn} = Styles;
    const [images, setImages] = useState();
    const [ favored, setFavored ] = useState(false);
    useEffect(() => {                                                              
	    getSignedImageUrl(`${id}/mainImg/${img}`).then( data => {
                setImages(data);
	    });
    }, []);
    useEffect(_=>{
	const arrFavors = JSON.parse(localStorage.getItem("favorites")) || [];
        setFavored(arrFavors.includes(id) || false);
    }, [viewWindow, viewRequest]);
    function addCommasToStringNumber(numberString="") {
        return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    const setFavorite = (event) =>{
        if(!localStorage.getItem("favorites")){
            localStorage.setItem("favorites", JSON.stringify([id]));
	    event.target.style.background = "#cfbf30"; 
	}
	else{
            let arr = JSON.parse(localStorage.getItem("favorites"));
	    if(!arr.includes(id)) {
		arr.push(id);
		event.target.style.background = "#cfbf30";
	    }
	    else {
 		arr.splice(arr.indexOf(id), 1);
		event.target.style.background = "#9f9f9f50";
	    }
	    localStorage.setItem("favorites", JSON.stringify(arr)); 
	}
	//alert(JSON.parse(localStorage.getItem("favorites")));
    };
    return (
        <div className = { Element }>
            <div className = { image }><img src = { images } alt = { title } loading='lazy'/></div>
            <div className = { caption }><h4><bdi>{ title }</bdi></h4><p><bdi>{ label }</bdi></p></div>
            <div className = { EventHandler }>
                <button onClick={ _=> {setViewWindow(true); setItemId(id); } }><i className = "bi bi-eye-fill"></i></button>
                <button><i style={{background: favored && "#cfbf30"}}  onClick={ setFavorite }  className = "bi bi-bookmark-star-fill"></i></button>
                <p><bdi>{ addCommasToStringNumber(price) } IQD</bdi></p>
            </div>
            <button className = { buyBtn } onClick = { _=> {setViewRequest(true); setItemId(id);} }>
                <i className = "bi bi-cart4"></i>
                <p>شراء</p>
            </button>
        </div>
    );
};
//View Window
export const ViewWindow   = ( props ) => {
    const { title, label, price, setViewWindow, setViewRequest, setItemId, itemId } = props;
    const { ViewWindow, image, content, listIndex, symbol } = Styles;
    const [ index,    setIndex    ] = useState(0);
    const [ itemData, setItemData ] = useState({});
    const [ img,      setImages   ] = useState([]);
    const [ favored,  setFavored  ] = useState(false);
    useEffect(_=>{
       getItem(itemId).then( data => {     
	   setItemData(data);   
       });
       getS3FolderImages(`${itemId}/album`).then( data => {    
	   setImages(data); 
       });
       const arrFavors = JSON.parse(localStorage.getItem("favorites")) || [];
       setFavored(arrFavors.includes(itemId) || false);
    }, []);
    function addCommasToStringNumber(numberString = "" ) {
	    return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    const setFavorite = (event) =>{ 
	if(!localStorage.getItem("favorites")){ 
		 localStorage.setItem("favorites", JSON.stringify([itemId]));
		event.target.style.background = "#cfbf30";
	}  
	else{ 
	    let arr = JSON.parse(localStorage.getItem("favorites")); 
	    if(!arr.includes(itemId)) {  
		arr.push(itemId);    
		event.target.style.background = "#cfbf30";
            }  
	    else {   
		arr.splice(arr.indexOf(itemId), 1);   
		event.target.style.background = "#9f9f9f50"; 
            } 
	    localStorage.setItem("favorites", JSON.stringify(arr));

        }   
	 //alert(JSON.parse(localStorage.getItem("favorites")));   
    };
    return(
        <div className = { ViewWindow }>
            <div>
            <header>
                <h1><bdi>{ itemData.title }</bdi></h1>
                <div className={ symbol }></div>
                <i className="bi bi-x-circle" onClick={ _=> setViewWindow(false) }></i>
            </header>
            <main>
                <div className = { image }>
                    <img src = { img[ index ] } alt = { itemData.title } loading = { "lazy" }/>
                    <div>
                        <button onClick = { _=> { index > 0 ? setIndex( index - 1 ): setIndex(img.length - 1) } }><i className = "bi bi-arrow-left-circle-fill"></i></button>
                        <button onClick = { _=> { index < (img.length - 1) ? setIndex( index + 1 ): setIndex(0); } }><i className = "bi bi-arrow-right-circle-fill"></i></button>
                        <div className={ listIndex }>{ img.map((value, key) => { return <i className = "bi bi-dot" style={{ color: key === index && "#e91e63" }} key={ key }></i> }) }</div>
                    </div>
                </div>
                <div className = { content }><p><bdi>{ itemData.description }</bdi></p></div>
            </main>
            <footer>
                <p><bdi>{ addCommasToStringNumber(itemData.price) } IQD</bdi></p>
                <div>
                    <button onClick = { _=> {setViewRequest(true); setItemId(itemId);} }><i className = "bi bi-cart4"></i><p>شراء</p></button>
                    <button><i style={{background: favored && "#cfbf30"}} onClick={setFavorite} className = "bi bi-bookmark-star-fill"></i></button>
                </div>
            </footer>
            </div>
        </div>
    );
};
//view request
export const ViewRequest  = ( props ) => {
    const { title, setViewRequest, setRequestState, setItemId, itemId } = props;
    const { ViewRequest, symbol, list, distirct, textArea } = Styles;
    let   form = {};
    const onInput = ( event ) => {
        const { value, style, id } = event.target;
        form = {...form, [id]: value};
        if(value.length > 0){ 
            style.border = "2px solid #e8e8e8";
            style.background = "rgba(245, 245, 245, 0.745)";
        }
        else {
            style.border = "2px solid #e91e6352";
            style.background = "#e91e6321";
        }
    };
    const sendToWtspp = (phoneNumber = "", message = "") => {
        let encodedMessage = encodeURIComponent(message);
        let whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappURL);
    };
    const onSubmit = ( event ) => {
        const { iraq_governorates = "", distirct = "", textArea = "", ID = "" } = form;
        event.preventDefault();
        if(!(iraq_governorates.length > 0)){  
            const { style } = document.querySelector(`#iraq_governorates`);
            style.border = "2px solid #e91e6352";
            style.background = "#e91e6321";
        }
        else if(!(distirct.length > 0)){  
            const { style } = document.querySelector(`#distirct`);
            style.border = "2px solid #e91e6352";
            style.background = "#e91e6321";
        }
        else if(!(textArea.length > 0)){  
            const { style } = document.querySelector(`#textArea`);
            style.border = "2px solid #e91e6352";
            style.background = "#e91e6321";
        }
        else{
	    function addCommasToStringNumber(numberString = "" ) {
		return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");   
	    }
	    getItem(itemId).then( data => {
        
                const message = `*ID:* \`${itemId}\`
*اسم العنصر:* ${data.title}
*السعر:* ${addCommasToStringNumber(data.price)}
*المحافظة:* ${iraq_governorates} 
*الناحية/القضاء:* ${distirct}
*اقرب نقطة دالة:* ${textArea}`;
                sendToWtspp("9647700220235", message);
                setRequestState(true);
                fetchStates().then(data => {
                    updateState({...data, orders: String(+data.orders + 1)});
                });
	    });
        }
    };
    return (
        <div className = { ViewRequest }>
            <form>
                <header>
                    <h1><bdi>{ title }</bdi></h1>
                    <div className={ symbol }></div>
                    <i className="bi bi-x-circle" onClick = { _=> setViewRequest(false) }></i>
                </header>
                <main>
                    <div className = { list }>
                        <select name="iraq-governorates" id={ "iraq_governorates" } onInput = { e => onInput(e) }>
                            <option value="">اختر محافظة</option>
                            <option value="بغداد">بغداد</option>
                            <option value="البصرة">البصرة</option>
                            <option value="نينوى">نينوى</option>
                            <option value="الأنبار">الأنبار</option>
                            <option value="النجف">النجف</option>
                            <option value="كربلاء">كربلاء</option>
                            <option value="ذي قار">ذي قار</option>
                            <option value="بابل">بابل</option>
                            <option value="واسط">واسط</option>
                            <option value="ديالى">ديالى</option>
                            <option value="القادسية">القادسية</option>
                            <option value="ميسان">ميسان</option>
                            <option value="صلاح الدين">صلاح الدين</option>
                            <option value="كركوك">كركوك</option>
                            <option value="أربيل">أربيل</option>
                            <option value="دهوك">دهوك</option>
                            <option value="حلبجة">حلبجة</option>
                            <option value="السليمانية">السليمانية</option>
                            <option value="المثنى">المثنى</option>
                        </select>
                    </div>
                    <div className = { distirct }><input id={ "distirct" } onInput={ e => onInput(e) } type={ "text" } placeholder={ "القضاء او الناحية" } required /></div>
                    <div className = { textArea }><input type={ "text" } id = {"textArea"} onInput={ e => onInput(e) } placeholder={ "...اقرب نقطة دالة مثلا: جامع" } required /></div>
                </main>
                <footer>
                    <button onClick={ e => onSubmit(e)}>
                        <i className="bi bi-whatsapp"></i>
                        <p>ارسال الطلب</p>
                    </button>
                </footer>
            </form>
        </div>
    );
};
//request state
export const RequestState = ( props ) => {
    const { state, setRequestState, setViewRequest, setViewWindow } = props;
    const { RequestState } = Styles
    return (
        <div className = { RequestState }>
            { state ? <State1 setRequestState = { setRequestState } setViewRequest = { setViewRequest }/> : <State0 setRequestState = { setRequestState } setViewRequest = { setViewRequest }/> }
        </div>
    );
};
const        State0       = ( props ) => {
    const { setRequestState, setViewRequest } = props;
    const { State0, symbol } = Styles;
    const onClick = _=>{
        setRequestState(false);
        setViewRequest(false);
    };
    return (
        <div className = { State0 }>
            <header>
                <i className = "bi bi-x-circle" onClick={ onClick }></i>
                <div className = { symbol }></div>
            </header>
            <main>
                <i className="bi bi-envelope-x-fill"></i>
                <p><bdi>حدث خطأ في التطبيق: لم يتم إرسال الطلب. يرجى المحاولة مرة أخرى لاحقًا.</bdi></p>
            </main>
            <footer>
                <button>
                    <i className = "bi bi-whatsapp"></i>
                    <p>يمكنك الطلب عبر</p>
                </button>
            </footer>
        </div>
    );
};
const        State1       = ( props ) => {
    const { setRequestState, setViewRequest } = props;
    const { State1, symbol } = Styles;
    const onClick = _=>{
        setRequestState(false);
        setViewRequest(false);
    };
    return (
        <div className = { State1 }>
            <header>
                <i className = "bi bi-x-circle" onClick={ onClick }></i>
                <div className = { symbol }></div>
            </header>
            <main>
                <i className="bi bi-envelope-check-fill" style={{ color: "#4caf50" }}></i>
                <p style={{ color: "#4caf50" }}><bdi>تم ارسال طلبك عبر Whatsapp</bdi></p>
            </main>
            <footer>
                <button onClick={ onClick }>
                    <i className = "bi bi-cart-check-fill"></i>
                    <p>تم</p>
                </button>
            </footer>
        </div>
    );
};
//loading
export const Loading      = ( props ) => {
    const { image, title } = props;
    const { Loading } = Styles;
    const [ loading, setLoading ] = useState(true);
    useEffect(_=>{
        setTimeout(_=> setLoading(false), 3000);
    }, [ loading ]);
    return (
        <div className = { Loading } style={{ opacity: !loading && "0" }}>
            <img src = { image } alt = { title } loading='eager'/>
            <p><bdi>{ title }</bdi></p> 
        </div>
    );
};
